<div class="container-fluid">
  <div *ngIf="loading; else loaded">
    <app-loading></app-loading>
  </div>

  <ng-template #loaded>
    <app-statistics-book
      [bookI18n]="bookI18n"
      (result)="filter($event)"
    ></app-statistics-book>
    <!-- Page Heading -->
    <div class="page-heading mb-4">
      <h1 class="h3 mb-2 text-gray-800">
        <i class="fas fa-archive"></i> {{ bookI18n?.allTitleI18n }}
      </h1>
      <p class="mb-4">This module displays all the archived books and allows you to manage them efficiently.</p>
    </div>

    <!-- DataTales Example -->
    <div class="card mb-4">
      <div class="card-body">
        <div class="table-responsive">
          <app-arvived-book-list
            (idEvent)="edit($event)"
            (viewEvent)="view($event)"
            (deleteEvent)="delete($event)"
            [books]="books$"
            [bookI18n]="bookI18n"
          ></app-arvived-book-list>
          <app-modal-book [bookI18n]="bookI18n" [id]="id"></app-modal-book>
        </div>
      </div>
    </div>
  </ng-template>
</div>
